

import React, { useRef, useState } from "react";
import { FaEnvelope, FaWhatsapp, FaFacebook, FaInstagram } from "react-icons/fa";
import emailjs from "emailjs-com";



function Contact() {
  const formRef = useRef();
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  // //// !!!!!!! USER ID , TEMPELTAE ID , SERVICE ID  !!!!!!!!!!!!!!
  const SERVICE_ID = "service_45ugkl6";
  const TEMPLATE_ID = "template_25j9ln9";
  const USER_ID = "b2t9usldA--IahSfj";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSent(false);
    try {
      await emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, USER_ID);
      setSent(true);
      formRef.current.reset();
    } catch (err) {
      setError("Failed to send message. Please try again later.");
    }
  };

  return (
    <section id="contact" className="flex flex-col items-center justify-center min-h-[80vh] px-2 py-12 sm:py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-teal-900">
      <div className="flex flex-col items-center w-full max-w-lg p-4 border shadow-2xl sm:max-w-xl bg-white/20 dark:bg-gray-900/40 backdrop-blur-md rounded-3xl sm:p-8 md:p-12 border-teal-700/20">
        <h2 className="mb-2 text-3xl font-extrabold tracking-tight text-center text-teal-300 sm:mb-4 sm:text-4xl drop-shadow-lg">Contact Me</h2>
        <p className="mb-4 text-base text-center text-gray-200 sm:mb-6 sm:text-lg">Let's connect! Email me at <span className="font-semibold text-teal-200">shaheerawan295@gmail.com</span></p>
        <form ref={formRef} className="flex flex-col w-full gap-4 animate-fade-in" onSubmit={handleSubmit}>
          <div className="flex flex-col gap-2">
            <label htmlFor="name" className="text-sm font-semibold text-left text-gray-300">Name</label>
            <input type="text" id="name" name="name" required className="px-4 py-2 text-white placeholder-gray-400 transition-all duration-200 border rounded-xl bg-gray-900/80 border-teal-700/30 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-teal-400" placeholder="Your Name" />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="email" className="text-sm font-semibold text-left text-gray-300">Email</label>
            <input type="email" id="email" name="email" required className="px-4 py-2 text-white placeholder-gray-400 transition-all duration-200 border rounded-xl bg-gray-900/80 border-teal-700/30 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-teal-400" placeholder="Your Email" />
          </div>
          <div className="flex flex-col gap-2">
            <label htmlFor="message" className="text-sm font-semibold text-left text-gray-300">Message</label>
            <textarea id="message" name="message" rows="4" required className="px-4 py-2 text-white placeholder-gray-400 transition-all duration-200 border resize-none rounded-xl bg-gray-900/80 border-teal-700/30 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-teal-400" placeholder="Your Message"></textarea>
          </div>
          <button type="submit" className="flex items-center justify-center gap-2 py-3 mt-2 font-bold text-white transition-all duration-300 shadow-lg rounded-xl bg-gradient-to-r from-teal-400 via-teal-500 to-teal-600 hover:from-teal-500 hover:to-teal-400 focus:outline-none focus:ring-4 focus:ring-teal-400/50">
            <FaEnvelope /> Send Message
          </button>
          {sent && <p className="mt-2 text-center text-green-400">Message sent successfully!</p>}
          {error && <p className="mt-2 text-center text-red-400">{error}</p>}
        </form>
        <div className="flex justify-center gap-6 mt-8">
          <a href="mailto:shaheerawan295@gmail.com" className="text-2xl text-teal-300 transition-colors hover:text-white" aria-label="Email"><FaEnvelope /></a>
          <a href="https://wa.me/923141480015" target="_blank" rel="noopener noreferrer" className="text-2xl text-teal-300 transition-colors hover:text-white" aria-label="WhatsApp"><FaWhatsapp /></a>
          <a href="https://www.facebook.com/share/14NR8kagX6N/" target="_blank" rel="noopener noreferrer" className="text-2xl text-teal-300 transition-colors hover:text-white" aria-label="Facebook"><FaFacebook /></a>
          <a href="https://www.instagram.com/shaheer_awan_24?igsh=MTcxNG45Nnl2Z3ZpZQ==" target="_blank" rel="noopener noreferrer" className="text-2xl text-teal-300 transition-colors hover:text-white" aria-label="Instagram"><FaInstagram /></a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
